import React, { useEffect } from "react";

import Grid from "@mui/material/Grid";

import useUser from "context/user/useUser";
import { getToken } from "auth/authenticate";
import axios from "axios";
import momentTz from "moment-timezone";

import FeatureDoctor from "../../components/common/featureDocter/FeatureDoctor";
import { Appointments } from "../../components/common/upcomingAppointment/appointments";
import PatientQuickActions from "./patientQuickActions.jsx";

import "./index.css";

function PatientDashboard() {
  const { settings } = useUser();
  const userId = settings?.userId;

  useEffect(() => {
    if (!userId) return;

    (async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}user/timezone/${userId}`,
          {
            headers: { Authorization: "Bearer " + getToken() },
            params: { userId },
          },
        );
        const fetched = response?.data?.data?.timezone;
        localStorage.setItem("Time-Zone", fetched || momentTz.tz.guess());
      } catch (err) {
        console.error("Error fetching timezone:", err);
        localStorage.setItem("Time-Zone", momentTz.tz.guess());
      }
    })();
  }, [userId]);

  const displayName = settings?.username || "there";

  return (
    <div className="dash">
      <header className="dash-hero">
        <h2 className="dash-hero__title">
          Hi {displayName}, how are you feeling today?
        </h2>
        <p className="dash-hero__sub">
          Book a consultation, review upcoming appointments, or explore
          featured specialists — all from one place.
        </p>
      </header>

      <Grid container spacing={{ xs: 2, md: 3 }}>
        {/* ---------- Appointments (primary) ---------- */}
        <Grid item xs={12} lg={8}>
          <div className="dash-stack">
            <section className="dash-slot dash-slot--appointments">
              <Appointments />
            </section>
          </div>
        </Grid>

        {/* ---------- Quick actions (sidebar) ---------- */}
        <Grid item xs={12} lg={4}>
          <div className="dash-stack">
            <section className="dash-slot dash-slot--quick-links">
              <PatientQuickActions />
            </section>
          </div>
        </Grid>

        {/* ---------- Featured doctors (full width spotlight) ---------- */}
        <Grid item xs={12}>
          <section className="dash-slot dash-slot--featured">
            <FeatureDoctor />
          </section>
        </Grid>
      </Grid>
    </div>
  );
}

export default PatientDashboard;